import { Logger } from '@grandstand-web/utils/logger'
import { getDeviceInfo } from './getDeviceInfo'

export const setDeviceInfo = async () => {
  if (!window.deviceInfo) {
    // This should never run on the server, and run only once on the client
    const logger = Logger.of('@grandstand-web/device-info/setDeviceInfo')
    try {
      const deviceInfo = await getDeviceInfo()
      logger.info('getDeviceInfo success', { deviceInfo })
      window.deviceInfo = deviceInfo
    } catch (error) {
      logger.error('getDeviceInfo failed', { error })
    }
  }
}
